import { AppLayout } from "layout";
import { ReviewEduContentData } from "../components";

type Props = {};

const ReviewEduContentContainer = (props: Props) => {

    return (
        <AppLayout>
            <ReviewEduContentData />
        </AppLayout>
    );
};

export default ReviewEduContentContainer;
